import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "general-error d-flex flex-column align-items-center" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-sad-face color-red" }, null, -1);
const _hoisted_3 = { class: "title" };
const _hoisted_4 = { class: "align-items-center" };
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = ["href"];
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-back-arrow" }, null, -1);
import { useStore } from 'vuex';
import { ref, computed } from 'vue';
// utilities
import { otoSupportEmail } from '@/utilities/constants';
// vuex
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalExportError',
    setup(__props) {
        // libs
        const store = useStore();
        // state
        const link = ref(otoSupportEmail);
        const mailToOtoSupport = ref(`mailto:${otoSupportEmail}`);
        // actions
        const setIsModalExportErrorVisible = (isVisible) => store.dispatch('engagementReport/setIsModalExportErrorVisible', isVisible);
        // computed
        const getIsModalVisible = computed(() => store.getters['engagementReport/getIsModalExportErrorVisible']);
        const closeModal = () => {
            setIsModalExportErrorVisible(false);
        };
        return (_ctx, _cache) => {
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                modelValue: getIsModalVisible.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((getIsModalVisible).value = $event)),
                id: "modal-export-error",
                "append-to-body": ""
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _hoisted_2,
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('audiences.exportation.error.title')), 1),
                        _createElementVNode("span", _hoisted_4, [
                            _createElementVNode("span", {
                                class: "subtitle",
                                innerHTML: _ctx.$t('audiences.exportation.error.subtitle')
                            }, null, 8, _hoisted_5),
                            _createElementVNode("a", {
                                class: "subtitle-link",
                                href: mailToOtoSupport.value
                            }, _toDisplayString(link.value), 9, _hoisted_6)
                        ]),
                        _createElementVNode("button", {
                            class: "btn btn-back",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (closeModal()), ["prevent"]))
                        }, [
                            _hoisted_7,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
                        ])
                    ])
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
